<template>

    <div class="row">
      <div class="col-12 card">
        <div class="row justify-content-space-between top-24">
          <h4 class="col-6 card-title">Привяжите ИНН компании к аккаунту</h4>
          <div class="col-6 align-self-end right">
            <!-- <router-link to="/"><button class="col-3 btn-secondary">Отменить</button></router-link> -->
            <!-- <button class="col-3 btn-primary"><span class="icon-Plus"></span>Сохранить</button> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12 top-24">
            <div class="text-field">
              <label class="text-field__label" for="search">Введите ИНН</label>
              <div class="col-8 text-field__icon">
                <input class="text-field__input" type="search" name="search" id="search" placeholder="Введите ИНН компании" v-model="inputInn">
              </div>
              <div class="col-12 text-field__icon">
                <button class="btn-primary" @click="CheckInn" ><span class="icon-Plus"></span>Проверить наличие договора</button>
              </div>
            </div>
 
          </div>
        </div>
        <div class="row" v-if=company_check>
          <div class="col-12 top-24">
            <div class="text-field">
              <label class="col-8 text-field__label" for="search">{{ this.polygon_company.CompanyName  }}</label>
              <div class="col-8 text-field__icon">
                Компания найдена. Вы можете привязать свой аккаунт к этой компании.
              </div>
              <div class="col-12 text-field__icon">
                <button class="btn-primary" @click="ConnectCompany" ><span class="icon-Plus"></span>Привязать</button>
              </div>
            </div>
            
          </div>
        </div>
        <div class="row" v-if=company_error>
          <div class="col-12 top-24">
            <div class="text-field">
              <label class="text-field__label" for="search">Компания с ИНН {{ inputInn }} не найдена.</label>
              <div class="col-8 text-field__icon">
                Компания с указанным ИНН отсутствует в списке контрагентов. Для уточнения деталей и заключения договора обратитесь по телефону 0000000.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
  import axios from 'axios'

    export default {
      data() {
        return {
          title: "ИНН компании",
          company_check: false,
          company_error: false,
          inputInn: null,
          polygon_company: []
        }
      },
      computed: {
        currentUser() {
          return this.$store.state.auth.user;
        },
      },
      methods: {
        CheckInn(e) {
          const baseURL = this.$store.state.domain+'/api/polygon/check_inn';
          const params = {
            "CompanyINN": this.inputInn
          }

          axios
            .get(baseURL, { params })
            .then(response => {
              console.log(response.data);
              this.polygon_company = response.data
              this.company_error = false
              this.company_check = true
            })
            .catch(e => {
              console.log(e);
              this.company_error = true
              this.company_check = false
            });
        },
        ConnectCompany() {
          console.log(this.currentUser.username)
          const baseURL = this.$store.state.domain+'/api/polygon/user/company';
          const params = {
            "username": this.currentUser.username,
            "company_name": this.polygon_company.CompanyName,
            "inn": this.inputInn
          }

          axios
            .post(baseURL, { params })
            .then(response => {
              console.log(response.data);
              this.currentUser.company_inn = this.inputInn
            })
            .catch(e => {
              console.log(e);
            });
        }
      }
    };
  </script>
